/*
 * @Descripttion: 
 * @version: 
 * @Author: Blau
 * @Date: 2023-10-17 17:40:00
 * @LastEditors: Andy
 * @LastEditTime: 2023-12-06 15:58:31
 */
import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
// import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'
import directive from './directive'
import '@/icons' // icon
import '@/permission' // permission control
import Avue from '@smallwei/avue' // avue
import '@smallwei/avue/lib/index.css' // avue css
import avueUeditor from 'avue-plugin-ueditor'
Vue.use(avueUeditor)
Vue.use(ElementUI, { locale })
Vue.use(Avue)
Vue.use(directive)
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js